export const validateTelefono = (phone) => {
  const phoneRegex = /^[0-9]{9,15}$/;
  return phoneRegex.test(phone);
};

export const validatePIVA = (piva) => {
  const pivaRegex = /^[0-9]{11}$/;
  return pivaRegex.test(piva);
};

export const validateCF = (cf) => {
  const cfRegex = /^[A-Z0-9]{16}$/;
  return cfRegex.test(cf);
};

export const validateCodiceRUI = (cf) => {
  const cfRegex = /^[A-Z0-9]{9}$/;
  return cfRegex.test(cf);
};

export const validateEmail = (email) => {
  // Simple email regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePassword = (password) => {
  // Your password regex
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!$%&()<>,.;:_])[A-Za-z\d!$%&()<>,.;:_]{8,16}$/;
  return passwordRegex.test(password);
};

export function deepTrimStrings(obj) {
  if (typeof obj === "string") return obj.trim();
  if (Array.isArray(obj)) return obj.map(deepTrimStrings);
  if (typeof obj === "object" && obj !== null)
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [key, deepTrimStrings(value)])
    );
  return obj;
}

export const validateForm = (tipologia, formState, setErrors) => {
  const errorsAzienda = {};
  const errorsResponsabile = {};

  const errorsCredenziali = {};
  const email = formState.credenziali.email || "";
  const password = formState.credenziali.password || "";
  const confermaPassword = formState.credenziali.confermaPassword || "";

  if (!email.trim()) {
    errorsCredenziali.email = "L'email è obbligatoria";
  } else if (!validateEmail(email)) {
    errorsCredenziali.email = "Email non valida";
  }

  if (!password) {
    errorsCredenziali.password = "La password è obbligatoria";
  } else if (!validatePassword(password)) {
    errorsCredenziali.password =
      "La password non rispetta i requisiti richiesti";
  }

  if (!confermaPassword) {
    errorsCredenziali.confermaPassword = "Conferma password obbligatoria";
  } else if (password !== confermaPassword) {
    errorsCredenziali.confermaPassword = "Le password non coincidono";
  }

  setErrors((prev) => ({
    ...prev,
    credenziali: errorsCredenziali,
  }));

  switch (tipologia) {
    case "persona":
      if (!formState.datiResponsabile.cognome.trim())
        errorsResponsabile.cognome = "Il Cognome è obbligatorio";
      if (!formState.datiResponsabile.nome.trim())
        errorsResponsabile.nome = "Il Nome è obbligatorio";
      if (!formState.datiResponsabile.cf.trim()) {
        errorsResponsabile.cf = "Il CF è obbligatorio";
      } else {
        const cf = validateCF(formState.datiResponsabile.cf);
        if (!cf) {
          errorsResponsabile.cf = "Il CF deve essere composto da 16 caratteri";
        }
      }
      if (!formState.datiResponsabile.provincia)
        errorsResponsabile.provincia = "La Provincia è obbligatorio";
      if (!formState.datiResponsabile.comune)
        errorsResponsabile.comune = "Il Comune è obbligatorio";
      if (!formState.datiResponsabile.cap)
        errorsResponsabile.cap = "Il CAP è obbligatorio";
      if (!formState.datiResponsabile.viacorso)
        errorsResponsabile.viacorso = "La Via, Corso è obbligatoria";
      if (!formState.datiResponsabile.indirizzo.trim())
        errorsResponsabile.indirizzo = "L'Indirizzo è obbligatorio";
      if (!formState.datiResponsabile.civico.trim())
        errorsResponsabile.civico = "Il Civico è obbligatorio";
      if (!formState.datiResponsabile.cellulare.trim())
        errorsResponsabile.cellulare = "Il Cellulare è obbligatorio";

      if (!formState.datiResponsabile.ivassRUI.sezioneRUI)
        errorsResponsabile.sezioneRUI = "La Sezione RUI è obbligatoria";
      if (!formState.datiResponsabile.ivassRUI.codiceRUI.trim()) {
        errorsResponsabile.codiceRUI = "Il Codice RUI è obbligatorio";
      } else {
        const codiceRUI = validateCodiceRUI(
          formState.datiResponsabile.ivassRUI.codiceRUI
        );
        if (!codiceRUI) {
          errorsResponsabile.codiceRUI =
            "Il Codice RUI deve essere composto da 9 caratteri";
        }
      }
      if (!formState.datiResponsabile.ivassRUI.dataIscrizioneRUI.trim())
        errorsResponsabile.dataIscrizioneRUI =
          "La Data Iscrizione RUI è obbligatoria";

      setErrors((prev) => ({ ...prev, datiResponsabile: errorsResponsabile }));
      break;

    case "ditta":
      //Dati Azienda
      if (!formState.datiAzienda.ragioneSociale.trim())
        errorsAzienda.ragioneSociale = "La Ragione Sociale è obbligatoria";
      if (!formState.datiAzienda.pIva.trim()) {
        errorsAzienda.pIva = "La P. IVA è obbligatoria";
      } else {
        const pIva = validatePIVA(formState.datiAzienda.pIva);
        if (!pIva) {
          errorsAzienda.pIva = "La P.IVA deve essere composto da 11 numeri";
        }
      }
      if (!formState.datiAzienda.provincia)
        errorsAzienda.provincia = "La Provincia è obbligatorio";
      if (!formState.datiAzienda.comune)
        errorsAzienda.comune = "Il Comune è obbligatorio";
      if (!formState.datiAzienda.cap)
        errorsAzienda.cap = "Il CAP è obbligatorio";
      if (!formState.datiAzienda.viacorso)
        errorsAzienda.viacorso = "La Via, Corso è obbligatoria";
      if (!formState.datiAzienda.indirizzo.trim())
        errorsAzienda.indirizzo = "L'Indirizzo è obbligatorio";
      if (!formState.datiAzienda.civico.trim())
        errorsAzienda.civico = "Il Civico è obbligatorio";
      if (!formState.datiAzienda.email.trim())
        errorsAzienda.email = "L'Email è obbligatoria";

      if (!formState.datiAzienda.ivassRUI.sezioneRUI)
        errorsAzienda.sezioneRUI = "La Sezione RUI è obbligatoria";
      if (!formState.datiAzienda.ivassRUI.codiceRUI.trim()) {
        errorsAzienda.codiceRUI = "Il Codice RUI è obbligatorio";
      } else {
        const codiceRUI = validateCodiceRUI(
          formState.datiAzienda.ivassRUI.codiceRUI
        );
        if (!codiceRUI) {
          errorsAzienda.codiceRUI =
            "Il Codice RUI deve essere composto da 9 caratteri";
        }
      }
      if (!formState.datiAzienda.ivassRUI.dataIscrizioneRUI.trim())
        errorsAzienda.dataIscrizioneRUI =
          "La Data Iscrizione RUI è obbligatoria";

      //Dati Responsabile
      if (!formState.datiResponsabile.cognome.trim())
        errorsResponsabile.cognome = "Il Cognome è obbligatorio";
      if (!formState.datiResponsabile.nome.trim())
        errorsResponsabile.nome = "Il Nome è obbligatorio";
      if (!formState.datiResponsabile.cf.trim()) {
        errorsResponsabile.cf = "Il CF è obbligatorio";
      } else {
        const cf = validateCF(formState.datiResponsabile.cf);
        if (!cf) {
          errorsResponsabile.cf = "Il CF deve essere composto da 16 caratteri";
        }
      }
      if (!formState.datiResponsabile.provincia)
        errorsResponsabile.provincia = "La Provincia è obbligatorio";
      if (!formState.datiResponsabile.comune)
        errorsResponsabile.comune = "Il Comune è obbligatorio";
      if (!formState.datiResponsabile.cap)
        errorsResponsabile.cap = "Il CAP è obbligatorio";
      if (!formState.datiResponsabile.viacorso)
        errorsResponsabile.viacorso = "La Via, Corso è obbligatoria";
      if (!formState.datiResponsabile.indirizzo.trim())
        errorsResponsabile.indirizzo = "L'Indirizzo è obbligatorio";
      if (!formState.datiResponsabile.civico.trim())
        errorsResponsabile.civico = "Il Civico è obbligatorio";
      if (!formState.datiResponsabile.cellulare.trim())
        errorsResponsabile.cellulare = "Il Cellulare è obbligatorio";

      if (!formState.datiResponsabile.ivassRUI.sezioneRUI)
        errorsResponsabile.sezioneRUI = "La Sezione RUI è obbligatoria";
      if (!formState.datiResponsabile.ivassRUI.codiceRUI.trim()) {
        errorsResponsabile.codiceRUI = "Il Codice RUI è obbligatorio";
      } else {
        const codiceRUI = validateCodiceRUI(
          formState.datiResponsabile.ivassRUI.codiceRUI
        );
        if (!codiceRUI) {
          errorsResponsabile.codiceRUI =
            "Il Codice RUI deve essere composto da 9 caratteri";
        }
      }
      if (!formState.datiResponsabile.ivassRUI.dataIscrizioneRUI.trim())
        errorsResponsabile.dataIscrizioneRUI =
          "La Data Iscrizione RUI è obbligatoria";

      setErrors((prev) => ({
        ...prev,
        datiAzienda: errorsAzienda,
        datiResponsabile: errorsResponsabile,
      }));
      break;

    case "societa":
      //Dati Azienda
      if (!formState.datiAzienda.tipologiaAzienda)
        errorsAzienda.tipologiaAzienda = "La Tipologia Azienda è obbligatoria";
      if (!formState.datiAzienda.ragioneSociale.trim())
        errorsAzienda.ragioneSociale =
          "Ragione Sociale / Cognome è obbligatorio";
      if (!formState.datiAzienda.pIva.trim()) {
        errorsAzienda.pIva = "La P. IVA è obbligatoria";
      } else {
        const pIva = validatePIVA(formState.datiAzienda.pIva);
        if (!pIva) {
          errorsAzienda.pIva = "La P.IVA deve essere composto da 11 numeri";
        }
      }
      if (!formState.datiAzienda.provincia)
        errorsAzienda.provincia = "La Provincia è obbligatorio";
      if (!formState.datiAzienda.comune)
        errorsAzienda.comune = "Il Comune è obbligatorio";
      if (!formState.datiAzienda.cap)
        errorsAzienda.cap = "Il CAP è obbligatorio";
      if (!formState.datiAzienda.viacorso)
        errorsAzienda.viacorso = "La Via, Corso è obbligatoria";
      if (!formState.datiAzienda.indirizzo.trim())
        errorsAzienda.indirizzo = "L'Indirizzo è obbligatorio";
      if (!formState.datiAzienda.civico.trim())
        errorsAzienda.civico = "Il Civico è obbligatorio";
      if (!formState.datiAzienda.email.trim())
        errorsAzienda.email = "L'Email è obbligatoria";

      if (!formState.datiAzienda.ivassRUI.sezioneRUI)
        errorsAzienda.sezioneRUI = "La Sezione RUI è obbligatoria";
      if (!formState.datiAzienda.ivassRUI.codiceRUI.trim()) {
        errorsAzienda.codiceRUI = "Il Codice RUI è obbligatorio";
      } else {
        const codiceRUI = validateCodiceRUI(
          formState.datiAzienda.ivassRUI.codiceRUI
        );
        if (!codiceRUI) {
          errorsAzienda.codiceRUI =
            "Il Codice RUI deve essere composto da 9 caratteri";
        }
      }
      if (!formState.datiAzienda.ivassRUI.dataIscrizioneRUI.trim())
        errorsAzienda.dataIscrizioneRUI =
          "La Data Iscrizione RUI è obbligatoria";

      //Dati Responsabile
      if (!formState.datiResponsabile.cognome.trim())
        errorsResponsabile.cognome = "Il Cognome è obbligatorio";
      if (!formState.datiResponsabile.nome.trim())
        errorsResponsabile.nome = "Il Nome è obbligatorio";
      if (!formState.datiResponsabile.cf.trim()) {
        errorsResponsabile.cf = "Il CF è obbligatorio";
      } else {
        const cf = validateCF(formState.datiResponsabile.cf);
        if (!cf) {
          errorsResponsabile.cf = "Il CF deve essere composto da 16 caratteri";
        }
      }
      if (!formState.datiResponsabile.provincia)
        errorsResponsabile.provincia = "La Provincia è obbligatorio";
      if (!formState.datiResponsabile.comune)
        errorsResponsabile.comune = "Il Comune è obbligatorio";
      if (!formState.datiResponsabile.cap)
        errorsResponsabile.cap = "Il CAP è obbligatorio";
      if (!formState.datiResponsabile.viacorso)
        errorsResponsabile.viacorso = "La Via, Corso è obbligatoria";
      if (!formState.datiResponsabile.indirizzo.trim())
        errorsResponsabile.indirizzo = "L'Indirizzo è obbligatorio";
      if (!formState.datiResponsabile.civico.trim())
        errorsResponsabile.civico = "Il Civico è obbligatorio";
      if (!formState.datiResponsabile.cellulare.trim())
        errorsResponsabile.cellulare = "Il Cellulare è obbligatorio";
      if (!formState.datiResponsabile.ivassRUI.sezioneRUI)
        errorsResponsabile.sezioneRUI = "La Sezione RUI è obbligatoria";
      if (!formState.datiResponsabile.ivassRUI.codiceRUI.trim()) {
        errorsResponsabile.codiceRUI = "Il Codice RUI è obbligatorio";
      } else {
        const codiceRUI = validateCodiceRUI(
          formState.datiResponsabile.ivassRUI.codiceRUI
        );
        if (!codiceRUI) {
          errorsResponsabile.codiceRUI =
            "Il Codice RUI deve essere composto da 9 caratteri";
        }
      }
      if (!formState.datiResponsabile.ivassRUI.dataIscrizioneRUI.trim())
        errorsResponsabile.dataIscrizioneRUI =
          "La Data Iscrizione RUI è obbligatoria";

      setErrors((prev) => ({
        ...prev,
        datiAzienda: errorsAzienda,
        datiResponsabile: errorsResponsabile,
      }));
      break;
    default:
      break;
  }
  return (
    Object.keys(errorsAzienda).length === 0 &&
    Object.keys(errorsResponsabile).length === 0 &&
    Object.keys(errorsCredenziali).length === 0
  );
};
